
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100 22c19.527 0 39.055 2.298 58.582 6.894A20 20 0 01174 48.362V140c0 10.573-8.205 19.23-18.595 19.951L164 178H36l8.596-18.049C34.206 159.231 26 150.574 26 140V48.362a20 20 0 0115.418-19.468C60.945 24.298 80.473 22 100 22zm-45 97a9 9 0 100 18 9 9 0 000-18zm90 0a9 9 0 100 18 9 9 0 000-18zM86 48H46a6 6 0 00-6 6v43a6 6 0 006 6h40a6 6 0 006-6V54a6 6 0 00-6-6zm68 0h-40a6 6 0 00-6 6v43a6 6 0 006 6h40a6 6 0 006-6V54a6 6 0 00-6-6z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    